<template>
  <div>
    <section class="flex">
      <div style="width: 100px;" class="flexnone">
        <Tabs >
          <TabPane label="流水"></TabPane>
        </Tabs>
      </div>
      <div>
        <search-list   @getdata="getData"></search-list>
      </div>
    </section>
    <section>
      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      >
      </table-list>
    </section>

  </div>
</template>

<script>
  import SearchList from '../../components/SearchList'
  import TableList from "components/TableList/index";
  import {reportflow} from "../../../../api/reporter";
  import {getProjects} from "../../../../api/common";
  import {formatDateTime} from "../../../../utils/format";


  export default {
    name: "FlowRate",
    components:{
      SearchList,
      TableList

    },
    created(){
      // this.init()
    },
    data(){
      return {
        columns:[
          {
            title:' '
          },
          {
            type:'index',
            title:'序号',
            align: 'center',
            width:70,

          },
          {
            title:' '
          },
          {
            title: '项目名称',
            key: 'projectName',
            align: 'center',
            width:170,
          },
          {
            title:' '
          },
          {
            title: '合同号',
            key: 'contractCode',
            align: 'center',
            width:150,
          },
          {
            title:' '
          },
          {
            title: '应收总金额',
            key: 'receivableAmount',
            align: 'center',
            width:130,
          },
          {
            title:' '
          },
          {
            title: '已收金额',
            key: 'receivedAmount',
            align: 'center',
            width:130,
          },
          {
            title:' '
          },
          {
            title: '租金',
            key: 'receivableAmountRentFee',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },
          {
            title: '服务费',
            key: 'receivableAmountServiceFee',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },
          {
            title: '押金',
            key: 'receivableAmountDepositFee',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },
          {
            title: '违约金',
            key: 'receivableAmountBreakFee',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },
          {
            title: '赔付',
            key: 'receivableAmountDamages',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },
          {
            title: '水费',
            key: 'receivableAmountWaterFee',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },
          {
            title: '电费',
            key: 'receivableAmountElecFee',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },
          {
            title: '停车费',
            key: 'receivableAmountParkFee',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },
          {
            title: '其他',
            key: 'receivableAmountOtherFee',
            align: 'center',
            width:100,
          },
          {
            title:' '
          },

        ],
        data:[],
        loading:false,
        current:1,
        total:0,
        searchData: null,
        page:1

      }
    },
    methods:{
      init() {
        let ret = {
          projectFids: [],
          type: 0,
          startTime: '',
          endTime: '',
          page: 1,
          limit: 10
        }
        let p1 = getProjects().then(res => {
          if (!res.data) {
            return
          }
          res.data.length > 0 && (ret.projectFids = [res.data[0].value])
        }).catch(error => {
        }).finally(() => {
          let date = new Date()
          let year = date.getFullYear()
          let month = date.getMonth()
          let day = date.getDate()
          ret.startTime = formatDateTime(new Date(year, month, day - 7), false)
          ret.endTime = formatDateTime(new Date(year, month, day - 1), false)
          this.searchData = ret

          this.reportflow()

        })
      },
      reportflow(){
        let params={
          ...this.searchData,
          page:this.page,
          limit:10
        }
        reportflow(params).then(res=>{
          if(!res.data){
            return
          }
          this.data=res.data.rows
          this.total=res.data.total
        }).catch(error=>{

        })
      },
      getData(params){
        this.current=1
        this.page=1
        this.searchData=params
        this.reportflow()

      },
      changePage(n){
        this.current = n;
        this.page = n
        this.reportflow()

      }
    }
  }
</script>

<style scoped>

</style>
